export class ScanTimeoutException extends Error {
  constructor(message = 'scan timed out before a matching stand was found') {
    super(message)
    this.name = 'ScanTimeoutException'
    // es5 ターゲットで instanceof を機能させる
    Object.setPrototypeOf(this, ScanTimeoutException.prototype)
  }
}
